import { currencyFormatter } from '@/utils'

export function formatCurrency({ price, decimals = 4, round = false, trailingZeros }: { price: number, decimals?: number, round?: boolean, trailingZeros?: boolean }) {
	return currencyFormatter({ 
		currencyCode: 'EUR', 
		decimals, 
		round, 
		trailingZeros: trailingZeros ?? true, 
		price
	})
}